import qs from 'qs'
import React from 'react'

export default function ordersReducer(state = {
  list: [],
  statusList: [],
  validDates: [],
  new: {
    basket: {
      line_items: {},
      replacements: {}
    },
    products: {},
    newFeaturedProducts: [],
    filters: {},
    possibleOrderLimit: false,
    confirmedProduct: null,
    hideConfirm: false,
    expandTitle: false,
    basket_total: 0,
    contentUrl: '',
    unavailableProducts: [],
    deliveryAddress: null,
    repairedProduct: null
  },
  completeList: [],
  completeListPaging: {
    number: 1,
    size: 10
  },
  savedList: [],
  savedListPaging: {
    number: 1,
    size: 10
  },
  order: {},
  orderNow: {},
  orderMeta: { outlets: { data: [] }, order_limit_details: {} },
  checkout: {},
  fetching: false,
  fetched: false,
  update_basket_fetching: false,
  update_basket_fetched: true,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_ORDERS_PENDING':
    case 'GET_ORDER_PENDING':
    case 'GET_ORDER_NOW_PENDING':
    case 'GET_NEW_ORDERS_PENDING':
    case 'GET_VALID_ORDER_DATES_PENDING':
    case 'GET_COMPLETE_ORDERS_PENDING': {
      return {
        ...state,
        complete_fetching: true,
        complete_fetched: false
      }
    }
    case 'UPDATE_BASKET_PENDING': {
      return {
        ...state,
        update_basket_fetching: true,
        update_basket_fetched: false,
      }
    }
    case 'GET_SAVED_ORDERS_PENDING': {
      return {
        ...state,
        saved_fetching: true,
        saved_fetched: false
      }
    }
    case 'GET_ORDERS_FULFILLED': {
      const data = action.payLoad.data.map((order) => {
        const attr = order.attributes;
        return {
          id: order["id"],
          type: order["type"],
          attributes: {
            order_type: attr["order-type"],
            order_number: attr["order-number"],
            your_reference: attr["your-reference"],
            outlet: attr["outlet"],
            status: attr["status"],
            user_id: attr["user-id"],
            sent_to_ituk: attr["sent-to-ituk"],
            invoice_received: attr["invoice-received"],
            invoice: attr["invoice"],
            order_total: attr["order-total"],
            created_at: attr["created-at"]
          }
        }
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        list: data,
        statusList: action.payLoad.meta.statuses
      }
    }
    case 'GET_NEW_ORDERS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        new: {
          ...state.new,
          filters: action.payLoad.meta.filter,
          contentUrl: action.payLoad.links["new-order-page"],
          possibleOrderLimit: action.payLoad.meta["possible-order-limit"],
          gameBanner: action.payLoad.meta["game-banner"],
          products: pushToObject(loadProductData(action.payLoad.data))
        }
      }
    }
    case 'GET_COMPLETE_ORDERS_FULFILLED': {
      const lastPage = action.payLoad.links.last;
      let page = state.completeListPaging;
      if (lastPage) {
        page = qs.parse(lastPage.split('?')[1]).page;
      }

      return {
        ...state,
        complete_fetching: false,
        complete_fetched: true,
        completeList: action.payLoad.data,
        completeListPaging: page
      }
    }
    case 'GET_ORDER_NOW_FULFILLED': {
      return {
        ...state,
        orderNow: action.payLoad.data,
      }
    }
    case 'GET_SAVED_ORDERS_FULFILLED': {
      const lastPage = action.payLoad.links.last;
      let page = state.savedListPaging;
      if (lastPage) {
        page = qs.parse(lastPage.split('?')[1]).page;
      }

      return {
        ...state,
        saved_fetching: false,
        saved_fetched: true,
        savedList: action.payLoad.data,
        savedListPaging: page
      }
    }
    case 'GET_ORDERS_REJECTED':
    case 'GET_ORDER_REJECTED':
    case 'GET_ORDER_NOW_REJECTED':
    case 'GET_NEW_ORDERS_REJECTED':
    case 'GET_COMPLETE_ORDERS_REJECTED':
    case 'GET_VALID_ORDER_DATES_REJECTED':
    case 'GET_SAVED_ORDERS_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      }
    }
    case 'GET_ORDER_FULFILLED': {
      return {
        ...state,
        order: action.payLoad.data,
        fetching: false,
        fetched: true,
      }
    }
    case 'GET_VALID_ORDER_DATES_FULFILLED': {
      return {
        ...state,
        validDates: action.payLoad.valid_dates,
        fetching: false,
        fetched: true,
      }
    }
    case 'DELETE_SAVED_ORDER_FULFILLED': {
      const newState = { ...state };
      newState.savedList = newState.savedList.filter(order => {
        return order.id !== action.payLoad
      });
      return newState;
    }
    case 'ADD_TO_BASKET': {

      state.new.basket.line_items[action.payLoad.id] = action.payLoad;
      const newBasket = { ...state.new.basket };
      return {
        ...state,
        new: {
          basket: newBasket,
          products: state.new.products
        }
      };
    }
    case 'UPDATE_BASKET_FULFILLED': {
      const hide = action.payLoad || false;
      return {
        ...state,
        new: {
          ...state.new,
          hideConfirm: hide,
          repairedProduct: null
        },
        update_basket_fetching: false,
        update_basket_fetched: true
      };
    }
    case 'REMOVE_FROM_BASKET': {
      delete state.new.basket[action.payLoad];
      const newBasket = { ...state.new.basket };
      state.new.products[action.payLoad] = Object.assign(state.new.products[action.payLoad], { product_qty: 0 });
      return {
        ...state,
        new: {
          basket: newBasket,
          products: state.new.products
        }
      }
    }
    case "ADD_REPLACEMENT_PRODUCT_FULFILLED": { return { ...state }; }
    case 'LOAD_BASKET_ITEMS': {

      let newBasket = action.payLoad.basket_data;
      const lineItems = createBasket(newBasket.line_items);
      newBasket.line_items = lineItems;
      let unavailableProducts = Object.values(lineItems).filter(line_item => {
        return line_item.product.stock_status == 'Out of Stock'
          || line_item.product.stock_status == 'Discontinued'
      })

      return {
        ...state,
        new: {
          ...state.new,
          basket: newBasket,
          basket_total: action.payLoad.basket_total,
          basket_total_with_current_promotions: action.payLoad.basket_total_with_current_promotions,
          basket_errors: action.payLoad.basket_errors,
          unavailableProducts: unavailableProducts
        }
      }
    }

    case 'CLEAR_PRODUCT_CONFIRMATION': {
      state.new.confirmedProduct = null;
      return {
        ...state
      };
    }

    case 'GET_ORDER_CONFIRM_FULFILLED': {
      return {
        ...state,
        checkout: action.payLoad.data,
        orderMeta: action.payLoad.meta,
      }
    }
    case 'CONFIRM_ORDER_FULFILLED': {
      return {
        ...state,
        confirmation: action.payLoad,
      }
    }
    case 'TOGGLE_THANK_YOU': {
      return {
        ...state,
        confirmation: undefined
      }
    }
    case 'TOGGLE_PRODUCT_CARD_TITLE': {
      const expandTitle = state.new.expandTitle;
      return {
        ...state,
        new: {
          ...state.new,
          expandTitle: !expandTitle,
        }
      }
    }
    case 'CONFIRM_PRODUCT': {
      state.new.confirmedProduct = action.payLoad;
      return {
        ...state
      };
    }
    case 'UPDATE_DELIVERY_ADDRESS': {
      return {
        ...state,
        new: {
          ...state.new,
          deliveryAddress: action.payload
        }
      };
    }
    case 'GET_NEW_FEATURED_PRODUCTS_PENDING': {
      return {
        ...state,
        fetching: true,
      }
    }
    case 'GET_NEW_FEATURED_PRODUCTS_REJECTED':
    case 'GET_NEW_FEATURED_PRODUCTS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        new: {
          ...state.new,
          newFeaturedProducts: action.payLoad
        }
      }
    }
    case 'LINE_ITEM_PRODUCT_REPAIRED': {
      const { new: newOrder } = state;
      const { productId: id, ...rest } = action.payload;

      return {
        ...state,
        new: {
          ...newOrder,
          repairedProduct: { id, ...rest }
        }
      }
    }
    case 'EMPTY_PRODUCT_REPAIRED': {
      const { new: newOrder } = state;
      return {
        ...state,
        new: {
          ...newOrder,
          repairedProduct: null
        }
      }
    }
    default: {
      return { ...state };
    }
  }
}

const loadProductData = (productList) => {
  return productList.map((order) => {
    const attr = order.attributes;
    return {
      ...order,
      id: order.id,
      type: order.type,
      attributes: {
        name: attr["name"],
        brand: attr['brand']['name'],
        category: attr['category']['name'],
        photo_uid: attr["photo-uid"],
        rsp: attr["rsp"],
        image: attr["links"]["image"],
        units_per_outer: attr["units-per-outer"],
        outer_price: attr["outer-price"],
        flavour: attr["flavour"],
        wording: attr["wording"],
        nicotine: attr["nicotine"],
        special_new: attr["special-new"] || false,
        missing_from_audit: attr["missing-from-audit"] || false,
        special_featured: attr["special-featured"] || false,
        special_reward: attr["special-reward"] || false,
        product_category_name: attr["product-category-name"],
        brand_id: attr["brand"]['id'],
        category_id: attr['category']['id'],
        stock_status: attr["stock-status"],
        status: attr['status'],
        promotion: attr["current-promotion"],
        upsell_popup: attr["current-upsell-popup"],
        expected_stock_date: attr["expected-stock-date"],
        replacement_product: attr["replacement-product"] || false,
        max_per_order: attr["max-per-order"] || 0,
        minimum_order_quantity: attr["minimum-order-quantity"] || 0
      }
    };
  });
};

const createBasket = (lineItems) => {
  let itemsObject = {};
  lineItems.forEach((curr) => {
    curr.product["image"] = curr.product.links.image;
    itemsObject[curr.product.id] = curr;
  });
  return itemsObject;
};

const pushToObject = (arrayList) => {
  let productsObject = {};
  arrayList.forEach((curr, index) => {
    curr.__index = index;
    productsObject[curr.id] = curr;
  });
  return productsObject;
};



// WEBPACK FOOTER //
// ./src/reducers/ordersReducer.js